import axios from 'axios';

const config = require('../config_actual.json');

const instance = axios.create({
  baseURL: config.server_url
});

export default instance;
